import { context } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/context.js?1733898722595';

export function get_domain(domain_url) {
    if (domain_url) {
        return domain_url;
    }
    const ctx = context();
    if (!ctx?.location?.origin) {
        return undefined;
    }
    return ctx.location.origin;
}
